import VideoLoader from './videoLoader.ui';

export default VideoLoader;
